<template>
  <UiBox class="ui-box-apply" bgType="light" layout="single">
    <template v-slot:nav-left>
      <UiTab class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">战队简介</span>
          <span class="label-text">战队简介</span>
        </div>
      </UiTab>
    </template>
    <template v-slot:nav-right>
      <div class="right-box">
        <button class="btn-exit" @click="handleExit"></button>
      </div>
    </template>
    <template v-slot:container>
      <div class="inner-container">
        <div class="scroll-box">
          <div class="info-box">
            <div class="row">
              <input type="text" v-model="team.name" maxlength="7" placeholder="战队名称(限制7个字)">
            </div>
            <div class="row">
              <textarea v-model="team.intro" placeholder="战队简介"></textarea>
            </div>
            <div class="row">
              <textarea v-model="team.player_intro" placeholder="队员介绍"></textarea>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="bg"></div>
          <UiButton class="btn prev" colorType="red" @click="prev">
            <div class="label-box">
              <span class="label-shadow">上一项</span>
              <span class="label-text">上一项</span>
            </div>
          </UiButton>
          <UiButton class="btn submit" colorType="gold" @click="submit">
            <div class="label-box">
              <span class="label-shadow">确认</span>
              <span class="label-text">确认</span>
            </div>
          </UiButton>
        </div>
      </div>
    </template>
  </UiBox>
</template>

<script setup>
import { reactive, inject } from 'vue'
import { usePrompt } from '@/composables/usePrompt'
import UiBox from '@/components/ui-box';
import UiTab from '@/components/ui-tab';
import UiButton from '@/components/ui-button';

const handleStepSubmit = inject('handleStepSubmit')
const handleStep = inject('handleStep')
const { showPrompt: promptMsg } = usePrompt()
const mockApply = inject('mockApply', null)

const emit = defineEmits(['confirm'])

const team = reactive({
  name: '',
  intro: '',
  player_intro: ''
})

function prev() {
  handleStep(3)
}

function validInfo() {
  let valid = true;
  if(!team['name']) {
    valid = false;
    promptMsg('请填写战队名称')
  }else if(!team['intro']) {
    valid = false;
    promptMsg('请填写战队简介')
  }else if(!team['player_intro']) {
    valid = false;
    promptMsg('请填写队员介绍')
  }

  return valid;
}

function submit() {
  if (mockApply?.bypassValidate) {
    handleStepSubmit(4, team);
    return
  }
  let valid = validInfo();
  if(valid) {
    handleStepSubmit(4, team);
  }
}

function handleExit() {
  emit('confirm')
}
</script>

<style lang="scss" scoped>
@import './_form';

// step4 独有
.title i {
  @include icon_status('info_2');
}

.inner-container {
  .scroll-box {
    .info-box {
      width: get_vw(822);
      margin: 0 auto;
      overflow: hidden;
      .row {
        width: 100%;
        margin-bottom: get_vh(19);
        input, textarea {
          border: get_vh(2) solid #CCCCCC;
          // 主体单轴 vh, 不混用 vw, 字号/padding 都跟 vh, 保证宽高比偏离时内部比例稳定
          font-size: get_vh(20);
          color: #333;
          padding-left: get_vh(25);
          outline: none;

          @media screen and (max-aspect-ratio: #{$design-w}/#{$design-h}) {
            font-size: get_vh(18);
          }
        }
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: #CCCCCC;
          opacity: 1; /* Firefox */
        }
        :input-placeholder { /* Internet Explorer 10-11 */
          color: #CCCCCC;
        }
        ::input-placeholder { /* Microsoft Edge */
          color: #CCCCCC;
        }

        input {
          width: get_vw(350);
          height: get_vw(64);
        }
        textarea {
          width: get_vw(790);
          height: get_vw(120);
          padding-top: get_vw(24);
          resize: none;
        }
      }
    }
  }
  .bottom-box {
    justify-content: space-between;
    .btn {
      &.prev {
        margin-left: get_vh(42);
      }
      &.submit {
        margin-right: get_vh(42);
      }
    }
  }
}
</style>